// JsFromRoutes CacheKey 6983880d23d71672278b633a13c81b33
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client";

export default {
  show: /* #__PURE__ */ definePathHelper(
    "get",
    "/admin/v2/programs/:program_id/purchase_proof_program_setting",
  ),
  update: /* #__PURE__ */ definePathHelper(
    "patch",
    "/admin/v2/programs/:program_id/purchase_proof_program_setting",
  ),
  create: /* #__PURE__ */ definePathHelper(
    "post",
    "/admin/v2/programs/:program_id/purchase_proof_program_setting",
  ),
};
